import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {
    getAcceptPrintsPublicationUrl,
    getMyPublicationUrl, getPrintsCertificationPublicationUrl,
    getPublicationAssignUrl,
    getPublicationByIdUrl,
    getPublicationCountNewUrl,
} from '../app.urls';
import {getPublicationUrl} from '../app.urls';
import {PublicationQueryModel, QueryModel} from '../models/query.model';
import {PublicationSaveModel} from '../models/publication.model';

@Injectable()
export class PublicationService {
    constructor(private http: HttpClient) { }

    getNewPublicaitonCount() {
        return this.http
            .get(getPublicationCountNewUrl());
    }

    getPublication(id: number) {
        return this.http.get(getPublicationByIdUrl(id));
    }
    getPublications(query?: any) {
        return this.http.get(getPublicationUrl(), {params: query});
    }
    getMyPublications(query?:any) {
        return this.http.get(getMyPublicationUrl(), {params: query});
    }

    deleteMyUntouchedPublications(id: number) {
        return this.http.delete(getMyPublicationUrl()+'/' + id.toString());
    }

    createPublication(publication: PublicationSaveModel) {
        return this.http.post(getPublicationUrl(), publication);

    }

    savePublicationWithoutIsbn(publication: PublicationSaveModel,id) {
        return this.http.put(getPublicationUrl()+'/'+id, publication);
    }
    savePublicationWithIsbn(publication: PublicationSaveModel,id) {
        return this.http.put(getPublicationAssignUrl()+'/'+id, publication);
    }

    acceptPrints(id:number) {

       return this.http.get(getAcceptPrintsPublicationUrl()+'/'+id );
    }

    downloadPrintCertification(id:number) {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
       return this.http.get(getPrintsCertificationPublicationUrl()+'/'+id,{ headers: headers, responseType: 'blob' as 'json' });
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/services/publication.service.ts